import session_jfrp from './session/jfrp'
import cookies from './cookies'

/**
 * 检查登录态
 */
export default function (appid) {
  if (appid) {
    let openid = cookies.get(appid + '_jfrp_id')
    let openkey = cookies.get(appid + '_jfrp_key')
    if (openid && openkey) {
      return new session_jfrp({
        openid,
        openkey
      })
    }
  }
  return false
}
